import { WidgetDataSource } from '../../../../../../../models';
import {
  Widget,
  WidgetGroup,
  Comparison,
} from '../../../../../../../providers/bridge-api/dashboard.service';
import { FieldService } from '../../../../../../../providers/storage-api/field.service';
import { WidgetImpactOptions } from '../../../../widget-impact/widget-impact.component';
import { AiInsightPayloadParams } from './widget-ai-insights-point-selection.service';
import { WidgetPointSelection } from './widget-point-selection';

export class ImpactPointSelection extends WidgetPointSelection {
  override assemblePayloadFromSelection(
    selectedPoints: any[],
    widget: Widget<WidgetImpactOptions>,
    dataSource: WidgetDataSource,
    widgetGroup?: WidgetGroup,
    comparison?: Comparison
  ): AiInsightPayloadParams {
    const payload = super.assemblePayloadFromSelection(
      selectedPoints,
      widget,
      dataSource,
      widgetGroup,
      comparison
    );

    const [ratingLow, ratingHigh] = widget.payload.ratingScale.split(':').map(Number);

    payload.scene_params.metric_calculation = widget.payload.scoringStrategy;
    payload.scene_params.best_rating_value = ratingHigh;
    payload.scene_params.worst_rating_value = ratingLow;
    payload.scene_params.rating_field = FieldService.getFieldLongName(widget.payload.ratingField);

    const flattenedPoints = selectedPoints.flat();
    for (let pointIdx = 0; pointIdx < flattenedPoints.length; pointIdx++) {
      const point = flattenedPoints[pointIdx];
      const bucket = payload.buckets[pointIdx];
      bucket.aggregate_rating_score = point.y;
    }

    switch (widget.payload.scoringStrategy) {
      case 'NPS':
        payload.scene_params.rating_score_high = 100;
        payload.scene_params.rating_score_low = -100;
        break;
      case 'BOX':
        payload.scene_params.rating_score_high = 100;
        payload.scene_params.rating_score_low = 0;
        payload.scene_params.box_options = `${widget.payload.boxDirection}:${
          widget.payload.boxSize
        }`;
        break;
      case 'AVERAGE':
        payload.scene_params.rating_score_high = ratingHigh;
        payload.scene_params.rating_score_low = ratingLow;
        break;
    }

    return payload;
  }

  protected override fillWidgetQueryOptionsForWidget(
    widgetQueryOptions: any,
    widget: Widget<WidgetImpactOptions>
  ): void {
    super.fillWidgetQueryOptionsForWidget(widgetQueryOptions, widget);

    // Add rating field and scale constraints for document filtering
    if (widget.payload.ratingField && widget.payload.ratingScale) {
      const [min, max] = widget.payload.ratingScale.split(':').map(Number);

      // Use bucket scoring query options to constrain by the rating field range
      widgetQueryOptions.bucketScoringQueryOptions = {
        fieldId: widget.payload.ratingField,
        minimumValue: min,
        maximumValue: max,
        includeMinimum: true,
        includeMaximum: true,
      };
    }
  }
}
